import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.toggled = false
    this.render()
    this.timer = setInterval(() => this.render(), 60_000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  toggle() {
    this.toggled = !this.toggled
    if (this.toggled) {
      this.element.textContent = new Date(this.element.dateTime).toLocaleString(undefined, {
        day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit"
      })
    } else {
      this.render()
    }
  }

  render() {
    if (this.toggled) return
    const diff = new Date(this.element.dateTime) - new Date()
    const minutes = Math.round(diff / 60_000)
    const hours = Math.round(diff / 3_600_000)
    if (minutes < 60) {
      this.element.textContent = `in ${minutes} ${minutes === 1 ? "minute" : "minutes"}`
    } else {
      this.element.textContent = `in ${hours} ${hours === 1 ? "hour" : "hours"}`
    }
  }
}
